import Icon from '../../Icon';

import * as S from './styles';

const Toast = ({ type, text }) => {
  const toaster = {
    success: (
      <S.Container>
        <Icon name="Check" color="#19ceb0" />
        <S.Text>{text}</S.Text>
      </S.Container>
    ),
    error: (
      <S.Container>
        <Icon name="CloseRegular" color="#FC2F59" />
        <S.Text>{text}</S.Text>
      </S.Container>
    ),
  };

  return toaster[type];
};

export default Toast;
